// @ts-nocheck

// Returns a copy of obj with value set at path (keys and array indexes), creating missing objects on the way.
export const setValueAtPath = (obj, path, value) => {
    if (!path.length) return value;

    const [key, ...rest] = path;
    const base = obj ?? (typeof key === 'number' ? [] : {});
    const copy = Array.isArray(base) ? [...base] : { ...base };
    copy[key] = setValueAtPath(base[key], rest, value);
    return copy;
};

// Value shown in the input while editing.
export const toInputValue = (type, value) => {
    if (value === undefined || value === null) return '';
    if (type === 'date') return String(value).slice(0, 10);
    if (type === 'boolean') return value ? 'true' : 'false';
    return String(value);
};

// Accepts Danish and plain formats: "45.000", "45000", "2,5" and "2.5".
const parseNumber = (raw) => {
    const text = String(raw).replace(/\s/g, '');
    if (text.includes(',')) return Number(text.replace(/\./g, '').replace(',', '.'));
    if (/^-?\d{1,3}(\.\d{3})+$/.test(text)) return Number(text.replace(/\./g, ''));
    return Number(text);
};

// Converts what was typed back to the stored value, keeping the type the field already had.
export const parseFieldValue = ({ type, raw, previous, options = [], storedType }) => {
    if (type === 'boolean') return raw === 'true';

    if (type === 'select') {
        const option = options.find(o => String(o.id) === String(raw));
        return option ? option.id : raw;
    }

    if (raw === '' || raw === null || raw === undefined) return type === 'number' && typeof previous === 'number' ? null : '';

    if (type === 'number') {
        const number = parseNumber(raw);
        if (!Number.isFinite(number)) return undefined;
        // Some amounts are stored as strings, keep them that way. New values follow the schema type (storedType).
        const storeAsString = previous === undefined || previous === null || previous === '' ? storedType === 'string' : typeof previous === 'string';
        return storeAsString ? String(number) : number;
    }

    return String(raw).trim();
};

const resolveSchemaRef = (schema, node) => {
    let current = node;
    while (current?.$ref) {
        current = current.$ref.replace(/^#\//, '').split('/').reduce((value, key) => value?.[key], schema);
    }
    return current;
};

// Finds the JSON schema node for a data path. Array indexes in the path point to the array's items.
export const getSchemaNode = (schema, path) => path.reduce((node, key) => {
    const resolved = resolveSchemaRef(schema, node);
    if (!resolved) return undefined;
    if (typeof key === 'number') return resolveSchemaRef(schema, resolved.items);
    return resolveSchemaRef(schema, resolved.properties?.[key]);
}, schema);

// Dropdown options for a field, as defined in the schema used by the edit form: [{ id, text }].
export const getSchemaOptions = (schema, path) => (getSchemaNode(schema, path)?.oneOf || [])
    .filter(option => option.const !== undefined)
    .map(option => ({ id: option.const, text: option.title ?? String(option.const) }));

export const getSchemaOptionText = (schema, path, value) => (
    getSchemaOptions(schema, path).find(option => String(option.id) === String(value))?.text
);
